import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { tomos } from '../data/content';
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="border-b border-line bg-canvasAlt" data-id="element-157" data-mp="3abvmjja9xvwm">
      <div className="mx-auto max-w-3xl px-4 py-9 text-center sm:px-6" data-id="element-158" data-mp="3ja7f3qupb3rp">
        <p className="font-display text-[0.65rem] font-bold uppercase tracking-[0.16em] text-accent" data-id="element-159" data-mp="3j8wchuczs226">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-2 font-display text-lg font-extrabold leading-tight text-ink sm:text-2xl" data-id="element-160" data-mp="3t7ltzm0z7khw">
          6 tomos en 1, pensados para aprender, practicar y construir
        </h2>
        <p className="mt-2 font-display text-sm font-extrabold uppercase text-accent" data-id="element-161" data-mp="5xe13phl5xv5">
          Mega Pack Electrónica para Emprender
        </p>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-ink-muted" data-id="element-162" data-mp="fua1t918tfp5">
          Es mucho más que una colección de información: es un sistema
          organizado que reúne fundamentos, componentes, circuitos, proyectos,
          diagnóstico y emprendimiento para ayudarte a pasar de la teoría a la
          acción.
        </p>

        <p className="mx-auto mt-3 inline-flex flex-wrap items-center justify-center gap-2 rounded-lg border border-volt/30 bg-volt-soft px-3 py-2 font-display text-[0.7rem] font-extrabold uppercase tracking-wide text-volt sm:text-xs" data-id="element-163" data-mp="3f9zeqig7nsq9">
          Aprender → Practicar → Construir → Emprender
        </p>

        <ol className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-164" data-mp="3u6gmkzp6yp82">
          {tomos.map((tomo, i) => <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-line bg-surface p-4 text-left" data-id="element-165" data-mp="2uox1mdhk69u" data-mpi={i}>
              <span className="flex items-center gap-1.5 font-display text-[0.65rem] font-bold uppercase tracking-[0.14em] text-accent" data-id="element-166" data-mp="gtocc3f3z8tc">
                <BookOpenIcon size={12} data-id="element-167" data-mp="2cxuran0f841z" />
                Tomo {i + 1}
              </span>
              <h3 className="mt-1.5 font-display text-sm font-extrabold uppercase leading-tight text-ink" data-id="element-168" data-mp="27yhtx8bxbel5">
                {tomo.title}
              </h3>
              <p className="mt-1.5 text-xs leading-relaxed text-ink-muted sm:text-sm" data-id="element-169" data-mp="2mopb7kq72rk9">
                {tomo.desc}
              </p>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}